/*El component notification d'Ant Design implementa els següents tipus de notificació:
success, error, info, warning (o warn), close i destroy*/
import { notification } from 'antd';

import { alturaNotificacioEnPixels } from '../constants';

notification.config({
    top: alturaNotificacioEnPixels,
    duration: 10
});

/**
 * @param tipus {String}
 * @param missatge {String}
 * @param descripcio {String}
 * @param class {String}
 * @returns function
 */
const crearNotificacio = (tipus, missatge, descripcio) => {
    const parametresNotificacio = {
        message: missatge,
        description: descripcio,       
        className: 'notificacio'
    };

    return notification[tipus](parametresNotificacio);
};

/**
 * @param titol {String}
 * @param descripcio {String}
 * @returns function
 */
export const crearNotificacioSuccess = (titol, descripcio) => {
    return crearNotificacio('success', titol, descripcio);
};

/**
 * @param titol {String}
 * @param descripcio {String}
 * @returns function
 */
export const crearNotificacioWarning = (titol, descripcio) => {
    return crearNotificacio('warning', titol, descripcio);
};

/**
 * @param titol {String}
 * @param descripcio {String}
 * @returns function
 */
export const crearNotificacioError = (titol, descripcio) => {
    return crearNotificacio('error', titol, descripcio);
};

/**
 * Crea una notificació per indicar que no s'han modificat valors en un formulari
 * @returns function
 */
export const crearNotificacioNoShanModificatValorsAlFormulari = () => {
    const notificacioCapValorModificatAdvertencia = 'No s\'ha modificat cap valor';
    return crearNotificacioWarning(notificacioCapValorModificatAdvertencia);
};

/**
 * Crea una notificació per indicar que la foto seleccionada supera la mida permesa
 * @param midaFitxer {String}
 * @param unitatImatge {String}
 * @param midaMaximaPermesaImatge {String}
 * @returns function
 */
export const crearNotificacioFotoSuperaMidaPermesa = (midaFitxer, unitatImatge, midaMaximaPermesaImatge) => {
    const notificacioFotoSuperaMidaPermesaAdvertencia = `La mida de la foto (${midaFitxer} ${unitatImatge}) excedeix el límit permés de ${midaMaximaPermesaImatge} ${unitatImatge}.`;
    return crearNotificacioWarning(notificacioFotoSuperaMidaPermesaAdvertencia);
};

/**
 * Crea una notificació per indicar que la foto seleccionada té una extensió no permesa
 * @returns function
 */
export const crearNotificacioFotoTipusNoPermes = () => {
    const notificacioFotoTipusNoPermesAdvertencia = 'L\'extensió de la foto no correspon a cap de les permeses: .png, .jpg, .gif, .bmp.';
    return crearNotificacioWarning(notificacioFotoTipusNoPermesAdvertencia);
};

/**
 * Crea una notificació per indicar el periode màxim que es pot seleccionar
 * @param periode {Number}
 * @returns function
 */
export const crearNotificacioSuperaPeriodeMaxim = (periode) => {
    const notificacioExcedeixPeriodeMaximAdvertencia = `La data d'inici ha de ser anterior o igual a la data de fi amb un màxim de ${periode} dies`;
    return crearNotificacioWarning(notificacioExcedeixPeriodeMaximAdvertencia);
};

/**
 * Crea una notificació per indicar que s'ha d'informar les dates obligatòriament
 * @returns function
 */
export const crearNotificacioDatesObligatories = () => {
    const notificacioDatesObligatoriesAdvertencia = 'Les dates han d\'estar informades';
    return crearNotificacioWarning(notificacioDatesObligatoriesAdvertencia);
};



// WEBPACK FOOTER //
// ./src/commons/notificacio.js